export enum AiSettingsType {
    EnableAiFeatures = 1,
    OutputLanguage = 2,
}
